import React, { ChangeEvent, useRef, useState } from "react";
import { useStoreDispatch } from "../../../store/hooks";
import { setBasicDialogOpenFor } from "../../../store/helpers/helperReducers";
import { Sheet } from "../../ui/sheet";
import { Button } from "../../ui/button";
import { Badge } from "../../ui/badge";
import { useTemplateDisplay } from "./hooks";
import { useSelector } from "react-redux";
import { isLoadingStatusSelector } from "../../../store/helpers/helperSelectors";
import { CloudUpload, Loader2, X } from "lucide-react";
import FileUpload from "../../ui/file-upload";

interface IAddCommissioningProps {
  modelOpenMode?: string;
  closeToDialogOpenFor?: string;
}

const FileImport: React.FC<IAddCommissioningProps> = ({ modelOpenMode = "Apply", closeToDialogOpenFor }) => {
  const { handleImportTempate } = useTemplateDisplay();
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [description, setDescription] = useState("");
  const dispatch = useStoreDispatch();
  const hiddenFileInput = useRef<HTMLInputElement | null>(null);
  const isLoadingStatus = useSelector(isLoadingStatusSelector);


  const handleImport = () => {
    if (selectedFile) {
      handleImportTempate(selectedFile, closeToDialogOpenFor, description);
      setSelectedFile(null);
      setDescription("");
    } else return;
  };

  const handleClose = () => {
    dispatch(setBasicDialogOpenFor(closeToDialogOpenFor));
  };

  const footer = (
    <>
      <Button variant="outline" onClick={handleClose}>
        Cancel
      </Button>
      <Button
        disabled={selectedFile === null}
        onClick={handleImport}
      >
        {isLoadingStatus["importFile"] && (
          <Loader2 className="h-4 w-4 animate-spin mr-1" />
        )}
        Upload
      </Button>
    </>
  );

  return (
    <Sheet open={true} onClose={handleClose} title={`${modelOpenMode} Template`} footer={footer} width="520px">
      <div className="space-y-2 pt-2">
        <p className="text-sm font-medium text-foreground mb-0.5">Upload a Template</p>
        <div className="w-full mt-2 mb-4">
          <FileUpload
            file={selectedFile}
            setFile={setSelectedFile}
            accept=".xml, .csv"
            allowedTypes={["text/xml", "application/xml", "text/csv", "application/csv"]}
            maxSizeMB={10}
          />
        </div>
        <div className="space-y-1">
          <label className="text-sm font-medium text-foreground" htmlFor="template-description-input">
            Description (optional)
          </label>
          <textarea
            id="template-description-input"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            rows={3}
            maxLength={500}
            className="flex w-full rounded-md border border-input bg-transparent text-foreground px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring resize-y"
            placeholder="Add a brief description for this template"
          />
        </div>
      </div>
    </Sheet>
  );
};

export default FileImport;